import { observable, computed } from 'mobx';

import { Model, App, ArrayApp } from 'core';

import { FileModel, FileApp } from 'apps/file/app';

export class SpaceSuggestionModel extends Model {
  static registryName = 'SpaceSuggestionModel';
  static ModelProps = {
    avatar: FileModel,
  };

  @observable slug = '';
  @observable imageFallbackChar = '';

  @computed get text() {
    return this.slug[0] === '+' ? this.slug : `@${this.slug}`;
  }
}

export class DirectoryFileModel extends Model {
  static registryName = 'DirectoryFileModel';
  static ModelProps = {
    file: FileModel,
  };

  @observable file = null;
  @observable dirname = '';
  @observable filename = '';
  @observable isFolder = false;
}

export class DirectoryFileApp extends App {
  static registryName = 'DirectoryFileApp';
  static AppProps = {
    file: FileApp,
  };

  static Model = DirectoryFileModel;
}

export class DirectoryFilesApp extends ArrayApp {
  static registryName = 'DirectoryFilesApp';
  static ElementApp = DirectoryFileApp;
}

export class DirectoryModel extends Model {
  static registryName = 'DirectoryModel';
  static ModelProps = {
    files: [DirectoryFileModel],
  };

  @observable files = [];

  @computed get path() {
    return this.files.length > 0 ? this.files.get(0).dirname : '';
  }
}

export class DirectoryApp extends App {
  static registryName = 'DirectoryApp';
  static AppProps = {
    files: DirectoryFilesApp,
  };

  static Model = DirectoryModel;
}
